module.exports = __webpack_public_path__ + "img/icon_ladder.f48807af.png";